export default __webpack_public_path__ + "static/18-7f842c54bc7312196002d947fd24ca4d.png";